<div [class.isPrinting]="printService.isPrinting">
  <div class="row margin-bottom-10px" id="edit-link">
    <div class="col-md-12">
      <div class="card box-shadow-new-treatmentcycle border-left-oqa" id="oqa">
        <div class="card-header wh-header border-bottom-1px padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
          <div class="row nav-link-hand margin-left-0px margin-right-0px background-new-oqa data-color-white">
            <div class="col-md-6 padding-right-0px">
              <label class="margin-bottom-0px font-size-16px font-weight-normal">
                <!--<i class="fas fa-circle light-gray-badge nav-link-hand  ">
                </i>-->
                Oocyte Quality Assessment
              </label>
            </div>
            <div class="col-md-6  text-align-end padding-right-0px display-edit">
              <div class="row  margin-left-0px margin-right-0px" *ngIf="OocyteData2">

                <div class="offset-md-5 col-md-2" *ngIf="OocyteData2.ActivityStatus !=='Completed'">
                  <!--<a class="nav-link-hand education-navlink " title="To View images">
      <span class="badge font-size-20px padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px"><i class="far fa-image"></i></span>
    </a>-->
                  <button type="button" class="btn actions-btn-prime float-right font-size-15px padding-right-0px padding-left-0px min-width-32px" (click)="Editoqa()"><i class="fas fa-pencil-alt"></i></button>
                </div>
                <div class="offset-md-5 col-md-2 padding-right-0px" *ngIf="OocyteData2.ActivityStatus =='Completed'">


                  <a class="nav-link-hand education-navlink" title="Detail" (click)="Editoqa()">
                    <span class="badge font-size-16px padding-right-0px"><i class="fa fa-info-circle"></i></span>
                  </a>

                </div>
                <div class="col-md-2 padding-right-5px">
                  <!--<a class="nav-link-hand education-navlink " title="To View images">
      <span class="badge font-size-20px padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px"><i class="far fa-image"></i></span>
    </a>-->
                  <button type="button" class="btn actions-btn-prime float-right font-size-15px padding-right-0px padding-left-0px min-width-32px" (click)="printoocyte()" *ngIf="GradingModel=='Well Culture'"><i class="fa fa-print"></i></button>
                  <button type="button" class="btn actions-btn-prime float-right font-size-15px padding-right-0px padding-left-0px min-width-32px" (click)="printoocytedroplet()" *ngIf="GradingModel=='Droplet Culture'"><i class="fa fa-print"></i></button>

                  <!--<a class="nav-link-hand education-navlink" *ngIf="GradingModel=='Well Culture'" title="print" (click)="printoocyte()">
      <span class="badge font-size-14 padding-left-0px"><i class="fa fa-print"></i></span>
    </a>
    <a class="nav-link-hand education-navlink" *ngIf="GradingModel=='Droplet Culture'" title="print" (click)="printoocytedroplet()">
      <span class="badge font-size-14 padding-left-0px"><i class="fa fa-print"></i></span>
    </a>-->

                </div>
                <div class="col-md-1 padding-left-11px">
                  <button type="button" (click)="Top()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-arrow-alt-circle-up color-green font-size-18px"></i>
                    <!--<i class="fas fa-long-arrow-alt-up font-size-11"></i>-->
                  </button>
                </div>
                <div class="col-md-1 padding-left-11px">
                  <!--<button type="button"
            class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
            name="upload">
      <i class="fas fa-plus font-size-11"></i>
    </button>-->
                  <button type="button" (click)="Bottom()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload" title="Goto Bottom">
                    <i class="fas fa-arrow-alt-circle-down color-green font-size-18px"></i>
                    <!--<i class="fas fa-long-arrow-alt-down font-size-11 "></i>-->
                  </button>
                </div>

              </div>
              <!--<a class="nav-link-hand education-navlink margin-right-10px " title="edit">
    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
  </a>-->
             
            </div>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <div class="row  margin-top-10">
            <div class="col-md-12 padding-left-24px">
              <div class="card border-all-1px">

                <div class="card-body padding-all-0px">
                  <div class="row" *ngIf="GradingModel=='Well Culture'">
                    <div class="col-md-12 ">
                      <div class="table-component margin-bottom-0px">
                        <div class="table-responsive">


                          <table class="table table-striped margin-left-zero">

                            <thead class="">
                              <tr>


                                <th class="padding-top-4px padding-bottom-4px width-47px font-weight-normal">Sno</th>
                                <th class="padding-top-4px padding-bottom-4px font-weight-normal">Well#</th>
                                <th class="padding-top-4px padding-bottom-4px font-weight-normal">Occ/Denuded</th>
                                <th class="padding-top-4px padding-bottom-4px font-weight-normal">Morphology</th>


                              </tr>
                            </thead>
                            <tbody class="table-body">
                              <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                              <!--</ng-container>-->
                              <tr *ngFor="let l of CurrentOocyteQualityAssessmentByCodeController;let i = index">


                                <td class="text-align-center padding-top-0px padding-bottom-0px padding-left-0px">{{i+1}}</td>
                                <td class="text-align-left padding-top-0px padding-bottom-0px padding-right-0px"><label class="margin-bottom-0px margin-left-5px">{{l.WellNo}}</label> </td>

                                <td class="padding-top-0px padding-bottom-0px">{{l.OocyteQualityPre}}/{{l.OocyteQualityPost}}</td>
                                <td class="padding-top-0px padding-bottom-0px">{{l.Morphology}}</td>
                                <td class="padding-all-0px">
                                  <!--<CodeTypeValue CodeType="InsTe" [(ngModel)]="l.technique" SelectedValue="l.technique"
                          required></CodeTypeValue>-->
                                  {{l.technique}}
                                </td>





                              </tr>
                            </tbody>

                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="GradingModel=='Droplet Culture'">
                    <!--<form class="form " novalidate="" #f="ngForm">-->
                    <div *ngIf="DenudationInfo">
                      <form class="form " novalidate="" (ngSubmit)="onSubmit3()" #f="ngForm">
                        <div class="accordion margin-top-5px" id="accordionExampleoqa4">

                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingoqa4">
                              <div class="row">
                                <div class="col-md-3">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseoqa4" aria-expanded="true" aria-controls="collapseoqa4">
                                      Denudation
                                    </button>
                                  </h5>
                                </div>

                                <div class="col-md-3">
                                  <!--<button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                </div>
                              </div>


                            </div>

                            <div id="collapseoqa4" class="collapse show" aria-labelledby="headingoqa4" data-parent="#accordionExampleoqa4">
                              <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                                <div class="card margin-bottom-0px margin-top-10">

                                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

                                    <div class="row margin-left-0px">
                                      <div class="col-md-3 padding-right-0px">
                                        <label class="margin-bottom-0px">
                                          Denudation By
                                        </label>
                                      </div>:
                                      <div class="col-md-3 padding-right-0px">
                                        <!--<CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                         id="DenudationInfo.DenudedByActor" SelectedValue="DenudationInfo.DenudedByActor"
                                                         [(ngModel)]="DenudationInfo.DenudedByActor" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                         name="DenudationInfo.DenudedByActor" required #DenudationBy="ngModel">
                                </CustomDataByRequestType>-->

                                        <label class="margin-bottom-0px ">{{DenudationInfo.DenudationBy}}</label>

                                      </div>

                                    </div>

                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>


                        </div>

                      </form>
                    </div>
                  </div>
                  <div *ngIf="GradingModel=='Droplet Culture'">
                    <div class="row margin-left-0px margin-right-0px">
                      <div class="col-md-12">
                        <label class="margin-bottom-0px font-size-18px">OQA</label>
                      </div>
                      <div class="col-md-2" *ngFor="let l of CurrentOocyteMaturityByCycleControllerNot0">

                        <div class="row margin-left-0px margin-right-0px background-clr-blue-03">
                          <div class="col-md-12 text-align-center">
                            <label class="margin-bottom-0px font-size-12px margin-left-3px font-weight-normal text-align-center">{{l.MaturityLevel}}</label>
                          </div>
                          <div class="col-md-12 text-align-center">
                            <label class="margin-bottom-0px  font-size-25px margin-left-3px font-weight-bold text-align-center">{{l.OccCount}}</label>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>

                  <div *ngIf="GradingModel=='Droplet Culture'">
                    <div class="row margin-left-0px margin-right-0px margin-top-5px">
                      <div class="col-md-12">
                        <label class="margin-bottom-0px font-size-18px">Oocyte Abnormalities</label>
                      </div>
                      <div class="col-md-2" *ngFor="let l of CurrentOocyteMorphologyByCycleControllerNot0">
                        <div class="row margin-left-0px margin-right-0px background-clr-blue-03">
                          <div class="col-md-12 text-align-center">
                            <label class="margin-bottom-0px font-size-12px margin-left-3px font-weight-normal text-align-center">{{l.Morphology}}</label>
                          </div>
                          <div class="col-md-12 text-align-center">
                            <label class="margin-bottom-0px  font-size-25px margin-left-3px font-weight-bold text-align-center">{{l.OocyteCount}}</label>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>

                  <!--<div class="row" *ngIf="GradingModel=='Droplet Culture'">

            <div class="col-md-6 ">
              <div class="table-component">
                <div class="table-responsive">


                  <table class="table table-striped margin-left-zero width-50-new overflow-y-hidden">
                    <caption>OQA</caption>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentOocyteMaturityByCycleController">


                        <td class="padding-top-4px padding-bottom-4px ">

                          <label class="margin-bottom-0px">{{l.MaturityLevel}}</label>
                        </td>
                        <td class="padding-top-4px padding-bottom-4px">

                          <label class="margin-bottom-0px font-size-18px">{{l.OccCount}}</label>
                        </td>

                      </tr>

                    </tbody>

                  </table>

                </div>
              </div>
            </div>
          </div>-->
                  <!--<div class="row" *ngIf="GradingModel=='Droplet Culture'">
            <div class="col-md-6 ">
              <div class="table-component">
                <div class="table-responsive">


                  <table class="table table-striped margin-left-zero width-50-new overflow-y-hidden">
                    <caption>Oocyte Abnormalities</caption>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentOocyteMorphologyByCycleController">


                        <td class="padding-top-0px padding-bottom-0px">

                          <label class="margin-bottom-0px">{{l.Morphology}}</label>
                         </td>
                        <td class="padding-top-0px padding-bottom-0px">

                          <label class="margin-bottom-0px font-size-18px">{{l.OocyteCount}}</label>
                        </td>

                      </tr>

                    </tbody>

                  </table>

                </div>
              </div>
            </div>
          </div>-->
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <ivf-additional-detail [CycleCode]='CycleCode'
                                     Title="Additional Information"
                                     Context="OqaAdnlDetail">
              </ivf-additional-detail>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>


  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
